<ng-container *ngIf="!loading">
  <div class="page-content" style="height: 100%">
    <section [ngClass]="{'is-not-full-screen':!isFullScreen}" style="display: flex; height: 100%">
      <gen-filter-panel-wrapper class="dashboard-filter-panel"
                                *ngIf="filterEnabled"
                                [type]="filterMainType"
                                [subtype]="filterType"
                                [enableStatistics]="enableStatistics"
                                [isFullScreen]="isFullScreen"
                                (updatePanelState)="updatePanelState($event)"
      >
      </gen-filter-panel-wrapper>
      <section class="worklist" [ngClass]="{'filter-panel-open': isFilterPanelOpen && filterEnabled, 'filter-panel-closed': !isFilterPanelOpen && filterEnabled}">
        <header *ngIf="showPatientHeader()" class="header profile-header patient-details-wrapper dashboard-header-wrapper">
          <gen-test-header-elements
                  class="content-item Flexbox Spacebox__lr-small patient-profile profile-header-section"
                  style="font-size: 1.21rem; flex-wrap: wrap; flex: 1 1 auto"
                  [patientId]=patientId>
          </gen-test-header-elements>
        </header>
        <header class="header profile-header">
          <div class="Flexbox">
            <div class="header-content contnet-filters Flexbox Flexbox__flex-1 fs5">
              <div class="title" *ngIf="searchText.length > 0 && !loading && !hideSearch">Search Result for "{{searchText}}"</div>
              <div class="title" *ngIf="searchText.length < 1">{{title | translate}}</div>
              <div class="Flexbox Flexbox__box-direction-column Flexbox__box-align-end general-action-buttons"
                   style="margin-left: auto">
                <div class="patient-search angucomplete-holder" id="test-search"
                     style="position: relative; padding-top: 0; font-size: 16px; line-height: normal;" >

                  <dls-searchbox *ngIf="!hideSearch" (search)="searchText = $event">
                    <input dlsInput placeholder="{{placeHolderText | translate}}"
                           [ngModel]="searchText"
                           [value]="searchText"
                           [id]="'worklistSearch'"
                           (ngModelChange)="searchText=$event;onSearchChange($event);">
                  </dls-searchbox>
                </div>
                <gen-export-worklist-data *ngIf="exportData" [exportOutSideClickClose]="exportData.outSideClickClose" [exportButtonText]="_exportConfig?.buttonTitle || 'Export List'"
                                          [exportOptions]="exportConfig?.options" [filterSelected]="_selectedFilter" [clientChunkSize]="worklistChunkSize"></gen-export-worklist-data>
                <gen-bulk-operation *ngIf="bulkOperationConfig && bulkOperationConfig.operations" [bulkOperationConfig]="bulkOperationConfig" [disabled]="bulkOperationDisabled"></gen-bulk-operation>
                <div *ngIf="dashboardFilters.length == 1" class="myworklist">
                  <div class="myWorklist-title">My Worklist</div>
                  <gen-toggle-switch
                          [active]="dashboardFiltersOptions[0]?.active"
                          [disabled]="antiSpamMyWorklistToggle"
                          (statusUpdate)="toggleSelection($event,true)"></gen-toggle-switch>
                </div>
                <div *ngIf="dashboardFilters.length > 1">
                  <gen-options-button class='export-worklist-data-wrapper'
                                      [buttonText]="'Filter'"
                                      [options]="dashboardFiltersOptions"
                                      [outSideClickClose]="true">
                  </gen-options-button>
                </div>
                <div style="flex-direction: row;display: flex;">

                  <div class="action-buttons-wrapper" *ngIf="showAddBtn">
                    <gen-button *ngIf="!checkRolePermissionForAddTest()" class="new-patient-add-button Auto_New_Test_Button"
                                (click)="addTest()"
                                [iconClass]="'icon__Plus1 new-patient-add-icon'"
                                [text]="addBtnLabel"
                                [disabled]="disableAddBtn"
                    ></gen-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
        <gen-filter-bucket #filterBucket *ngIf="filterBucketEnabled"
                           [_resource]="resource"
                           [dynamicSearchWithAllItemsBucket]="dashboardConfig?.dynamicSearchWithAllItemsBucket"
                           [showZeroCountFilter]="dashboardConfig?.showZeroCountFilter"
                           [_association]="associationItems"
                           [type]="filterMainType"
                           [subtype]="filterType"
                           [filterList]="savedFiltersList"
                           [dynamicSearch]="dynamicSearchConfig"
                           [worklistQuickFiltersConfig]="dashboardConfig?.quickFilters"
                           [worklistTemplate]="dashboardConfig"
                           [adaptableFilters]="adaptableBucketFiltersConfig">
        </gen-filter-bucket>

        <div *ngIf="appliedFilterProperties?.length > 0" class="Flexbox flex-wrap-wrap Spacebox__l-regular Spacebox__r-medium Spacebox__b-small" style="border-bottom: 1px solid #ccc; margin-top: 0; ">
          <div style="display:flex">
            <div *ngFor="let appliedFilter of appliedFilterProperties" class="Spacebox__r-small fs8 Spacebox__t-small">
              <gen-applied-filter id="{{'appliedFilter_' + appliedFilter.name}}"
                                          [filter]="appliedFilter" (newFilterEvent)="clearHighlightedClass($event)"
              >
              </gen-applied-filter>
            </div>
            <div class="Flexbox Flexbox__just-center Flexbox__box-align-center">
              <span *ngIf="appliedFilterProperties?.length > 0"
                    id="clearAllAppliedFilters"
                    class="fs7 pointer Spacebox__t-small"
                    style="color: #1076a6; font-family: 'CentraleSans Book'"
                    (click)='clearAllAppliedFilters()'>{{'Clear all filters' | translate}}
              </span>
            </div>
          </div>
        </div>
        <gen-overlay-loader *ngIf="loading" class="dashboard-worklist-overlay-loader"></gen-overlay-loader>
        <gen-worklist *ngIf="appliedFilterQueryObj != -1 || !filterEnabled"
                      class="dashboard-worklist worklist" style="height: 100%"
                      [ngClass] ="[worklistType, filterBucketEnabled ? 'worklist-with-filter-bucket' : 'worklist-without-filter-bucket', appliedFilterProperties?.length > 0 ? 'applied-filter': '']"
                      [searchPropagation]="worklistSearchPropagation"
                      [searchResource]="searchResource"
                      [resource]="worklistType"
                      [searchText]="!hideSearch ? searchText : ''"
                      [actions]="[]"
                      [load]="loading"
                      [appliedFilterObj]="appliedFilterQueryObj"
                      [resetWorklist]="resetWorklist"
                      [appliedFilterProperties]="appliedFilterProperties"
                      (rowClicked)="onRowClick($event.data)"
                      (reloadTriggered)="reloadTriggered($event)"
                      (bulkOperationDisabledStatus)="setBulkOperationDisabledStatus($event)"
        ></gen-worklist>
      </section>
    </section>
  </div>
</ng-container>
<gen-dynamic-modal-loader class="pan-cancer-event-modal" [observableName]="'NewCaseChannel'"></gen-dynamic-modal-loader>
<gen-dynamic-modal-loader [observableName]="'ShowWarningChannel'"></gen-dynamic-modal-loader>
<ng-container *ngIf="loading">
  <gen-overlay-loader [showOverlay]="true"></gen-overlay-loader>
</ng-container>
